import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  TooltipProps
} from 'recharts';

interface EmpresaData {
  id: string;
  nombre: string;
  usersCount: number;
  maxUsers: number;
  activeBotsCount: number;
  totalTexts?: number;
}

export interface EmpresasChartProps {
  data: EmpresaData[];
}

const EmpresasChart: React.FC<EmpresasChartProps> = ({ data }) => {
  // Preparar datos para el gráfico
  const chartData = data.map(empresa => ({
    name: empresa.nombre.length > 15 
      ? `${empresa.nombre.substring(0, 15)}...` 
      : empresa.nombre,
    usuarios: empresa.usersCount,
    bots: empresa.activeBotsCount,
    textos: empresa.totalTexts || 0
  }));

  // Personalizar tooltip
  const CustomTooltip = ({ 
    active, 
    payload, 
    label 
  }: TooltipProps<number, string>) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 shadow-md rounded-md border border-gray-200">
          <p className="font-medium mb-1">{label}</p>
          {payload.map((entry, index) => (
            <p key={`item-${index}`} style={{ color: entry.color }}>
              {entry.name}: {entry.value}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full" style={{ height: '400px' }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 70
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="name" 
            height={60}
            angle={-45}
            textAnchor="end"
          />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey="usuarios" fill="#4f46e5" name="Usuarios" />
          <Bar dataKey="bots" fill="#10b981" name="Bots Activos" />
          <Bar dataKey="textos" fill="#f59e0b" name="Textos" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default EmpresasChart; 